import { useMemo } from 'react'
import classNames from 'classnames'

import { useTranslate } from 'lib/tolgee'

import { translations } from './video-icon-status.i18n'
import type { IVideoIconStatus, IVideoIconStatusReturnProps } from './video-icon-status.types'
import { ENTITY_UPDATE_STATUS } from '../common/posts.consts'

export function useVideoIconStatus({ statusPost, postUrl }: IVideoIconStatus): IVideoIconStatusReturnProps {
  const t = useTranslate()

  const isClickable = useMemo(() => {
    return statusPost === ENTITY_UPDATE_STATUS.SUCCESS && !!postUrl
  }, [statusPost, postUrl])

  const tooltipIconPost = useMemo(() => {
    if (isClickable) {
      return t(translations.success)
    }
    if (statusPost === ENTITY_UPDATE_STATUS.RUNNING) {
      return t(translations.running)
    }
    if (statusPost === ENTITY_UPDATE_STATUS.FAILED) {
      return t(translations.failed)
    }
    return ''
  }, [isClickable, statusPost, t])

  const iconType = useMemo(() => {
    return statusPost in ENTITY_UPDATE_STATUS ? statusPost : null
  }, [statusPost])

  const showTooltip = useMemo(() => {
    return !!statusPost && !!tooltipIconPost
  }, [statusPost, tooltipIconPost])

  const isSuccessClickable = iconType === ENTITY_UPDATE_STATUS.SUCCESS && isClickable

  const iconWrapperClasses = classNames('VideoIconStatus__icon-wrapper', {
    'VideoIconStatus__icon-wrapper--clickable': isClickable,
    'VideoIconStatus__icon-wrapper--success': iconType === ENTITY_UPDATE_STATUS.SUCCESS,
    'VideoIconStatus__icon-wrapper--success-clickable': isSuccessClickable,
  })

  return {
    tooltipIconPost,
    iconType,
    showTooltip,
    postUrl,
    isClickable,
    isSuccessClickable,
    iconWrapperClasses,
  }
}
